import {
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";

export const MSPromptTitle = declareString("promptLibrary.mspromptTitle", {
  text: "Microsoft Prompts",
  comment:
    "Title that appears on the collection page for Microsoft prompts. This string is located at the heading section of the prompts collection page.",
});

export const SearchResultsTitle = declareStringWithPlaceholders(
  "promptLibrary.searchResultsTitle",
  {
    text: ({
      queryText,
      numOfResults,
    }: {
      queryText: string;
      numOfResults: string;
    }) => `Results for ${queryText} (${numOfResults})`,
    placeholders: {
      queryText: "Search text provided into search bar",
      numOfResults: "Number of search results",
    },
    comment: `Title that appears on the collection page when search results are displayed. This string is located at the heading section of the prompts collection page.`,
  }
);

export const SavedPromptTitle = declareString(
  "promptLibrary.savedpromptTitle",
  {
    text: "Prompts you've saved",
    comment:
      "Title that appears on the collection page for Saved Prompts. This string is located at the heading section of the prompts collection page.",
  }
);

export const TeamsPromptTitle = declareString(
  "promptLibrary.teamspromptTitle",
  {
    text: "Prompts from your teams",
    comment:
      "Title that appears on the collection page for team Prompts. This string is located at the heading section of the prompts collection page.",
  }
);

export const LikedPromptTitle = declareString(
  "promptLibrary.likedpromptTitle",
  {
    text: "Prompts you've liked",
    comment:
      "Title that appears on the collection page for liked Prompts. This string is located at the heading section of the prompts collection page.",
  }
);

export const AgentsPromptTitle = declareString(
  "promptLibrary.agentsPromptTitle",
  {
    text: "Prompts for agents",
    comment: "Agent prompts title",
  }
);
export const SearchPromptsTitle = declareString(
  "promptLibrary.searchPromptsTitle",
  {
    text: "Search Results",
    comment:
      "Title that appears on the collection page for agents Prompts. This string is located at the heading section of the prompts collection page.",
  }
);

export const WorkplacePromptsTitle = declareString(
  "promptLibrary.workplacePromptsTitle",
  {
    text: "Browse prompts from your organization",
    comment:
      "Title that appears on the collection page for workplace Prompts..",
  }
);

export const WorkplacePromptsFromTenantTitle = declareStringWithPlaceholders(
  "promptLibrary.workplacePromptsFromTenantTitle",
  {
    text: ({ tenantName }: { tenantName: string }) => `${tenantName} prompts`,
    placeholders: {
      tenantName: "Name of the organization / tenant.",
    },
    comment:
      "Title that appears on the collection page for workplace Prompts authored by the tenant.",
  }
);

export const AllPromptsTitle = declareString("promptLibrary.allPromptsTitle", {
  text: "Browse prompts",
  comment: "Title that appears on the collection page for all Prompts..",
});

export const WorkplacePromptsSubParapgraph = declareString(
  "promptLibrary.workplacePromptsSubParapgraph",
  {
    text: "Once prompts have been added, you'll be able to access prompts created and published by your organization here. In the meantime, get started with prompts provided by Microsoft.",
    comment:
      "Subheading displayed on the screen when the request to fetch Workplace prompts from the server-side retruns zero results.",
  }
);
